//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ExposeUserClaimsToCalculations: FeatureFlag = {"Id":"ExposeUserClaimsToCalculations","Label":"[10.23]Expose user claims to calculations","Impact":"Capture allowlisted IdP claims at login and persist them on the user so the UserClaim calculation setting can resolve them in form calculations. Requires per-provider/per-policy AllowedClaims configuration.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
